import { type FC, memo } from 'react';
import './styles.css';
import {
  SvgWrapper,
  type SvgWrapperProps,
} from '@ipfabric/ui-components/SvgWrapper/SvgWrapper';

const BareEyeIcon: FC<SvgWrapperProps> = (props) => (
  <SvgWrapper width='15' height='10' {...props}>
    <path
      d='M14 4.5a7.685 7.685 0 00-2.979-2.76c.315.532.48 1.14.477 1.759a3.5 3.5 0 01-7 0 3.417 3.417 0 01.477-1.76A7.683 7.683 0 002 4.5a8.068 8.068 0 002.607 2.553 6.549 6.549 0 006.794 0 8.07 8.07 0 002.6-2.552zm-5.629-3a.374.374 0 00-.375-.375 2.389 2.389 0 00-2.377 2.377.375.375 0 00.75 0A1.628 1.628 0 018 1.872a.373.373 0 00.375-.374l-.004.002zm6.63 3c-.005.19-.058.376-.157.539a8.293 8.293 0 01-2.943 2.88 7.572 7.572 0 01-7.81 0 8.348 8.348 0 01-2.943-2.876 1.009 1.009 0 010-1.08 8.348 8.348 0 012.943-2.876 7.56 7.56 0 017.81 0 8.349 8.349 0 012.943 2.877c.098.162.152.346.156.536z'
      fill='currentColor'
      className='svgicon__hover-hide'
    />
    <path
      d='M14 4.5a7.685 7.685 0 00-2.979-2.76c.315.532.48 1.14.477 1.759a3.5 3.5 0 11-6.523-1.76A7.683 7.683 0 002 4.5a8.068 8.068 0 002.607 2.553 6.549 6.549 0 006.794 0 8.07 8.07 0 002.6-2.552zm-5.629-3a.374.374 0 00-.375-.375A2.389 2.389 0 005.62 3.502a.375.375 0 00.75 0A1.628 1.628 0 018 1.872a.373.373 0 00.375-.374l-.004.002zm6.63 3a1.08 1.08 0 01-.157.539 8.292 8.292 0 01-2.943 2.88 7.572 7.572 0 01-7.81 0 8.348 8.348 0 01-2.943-2.876 1.009 1.009 0 010-1.08 8.348 8.348 0 012.943-2.876 7.56 7.56 0 017.81 0 8.347 8.347 0 012.943 2.877c.098.162.152.346.156.536z'
      fill='currentColor'
      className='svgicon__hover-show'
    />
  </SvgWrapper>
);
export const EyeIcon = memo(BareEyeIcon);
